import { useEffect, useRef } from "react";

import throttle from "lodash.throttle";

import { RichText } from "@atlassiansox/bxp-content-framework";

import { Container, Column } from "../../components";
import { UiStorylineModel } from "../../models";
import { renderViewModel } from "../../render-view-model";
import { getColorsFromBackgroundField } from "../../styles";

import { Storyline, StorylineRow } from "./UiStoryline.styles";

type UiStorylineProps = {
    readonly model: UiStorylineModel;
};

const UiStoryline = ({ model }: UiStorylineProps) => {
    const { stories, background } = model.content;

    const refs = useRef<HTMLDivElement[]>([]);

    useEffect(() => {
        //check the stories to see if they're higher than the window midpoint
        const checkStories = throttle(() => {
            const midpoint = window.innerHeight / 2 - 90; //90 for the dot's margin-top
            refs.current.forEach((div) => {
                div.classList.toggle(
                    "active",
                    div.getBoundingClientRect().top < midpoint
                );
            });
        }, 100);

        //fire on render in case
        checkStories();

        //add event listener
        window.addEventListener("scroll", checkStories, { passive: true });

        //clean up event listener when unmounting
        return () => {
            window.removeEventListener("scroll", checkStories);
        };
    }, []);

    return (
        <Storyline
            data-testid="storyline"
            {...getColorsFromBackgroundField(background)}
        >
            <Container>
                {stories.map(({ content }, index) => (
                    <StorylineRow
                        key={index}
                        // @ts-ignore - Ref callback type incompatibility
                        ref={(div: HTMLDivElement) =>
                            (refs.current[index] = div)
                        }
                    >
                        <Column
                            xs={{ top: "cozy" }}
                            md={{
                                align: "right",
                                bottom: "comfortable",
                                right: "cozy",
                                span: "6",
                                top: "comfortable"
                            }}
                        >
                            {renderViewModel(content.content)}
                        </Column>
                        <Column
                            xs={{ align: "left", bottom: "cozy" }}
                            md={{
                                bottom: "comfortable",
                                left: "cozy",
                                span: "6",
                                top: "comfortable"
                            }}
                        >
                            <RichText document={content.caption} />
                        </Column>
                    </StorylineRow>
                ))}
            </Container>
        </Storyline>
    );
};

export default UiStoryline;
